/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2024-01-15 14:16:37
 * @LastEditors: caiqin.xie
 * @message:
 */
export const i18n = {
  en: {
    '1_Year_Basic_Warranty': '1 Year Basic Warranty', // 仅为测试数据，具体来源为starling配置
    '365_equity': '365 day basic warranty', // 仅为测试数据，具体来源为starling配置
    '2_Years_Basic_Warranty': '2 Years Basic Warranty', // 仅为测试数据，具体来源为starling配置
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  de: {
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  fr: {
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  it: {
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  es: {
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  jp: {
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  ko: {
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  zh: {
    '1_Year_Basic_Warranty': '1年基础保修', // 仅为测试数据，具体来源为starling配置
    '365_equity': '365天基础保修', // 仅为测试数据，具体来源为starling配置
    '2_Years_Basic_Warranty': '2年基础保修', // 仅为测试数据，具体来源为starling配置
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: '首页',
    header_blog: '博客',
    header_software: '软件',
    header_about: '关于我们',
    header_fittings: '配件',
    header_support: '服务支持',
    header_shop: '门店',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: '活动',
    support_home_banner_search_Software: '软件',
    support_home_banner_search_Hardware: '硬件',
    support_home_banner_search_Streaming: '串流',
    support_home_banner_search_Policy: '热门问题',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  },
  ['th-TH']: {
    common_learn_more: "Learn More",
    common_load_more: 'Load More',
    common_search: 'Search',
    common_submit: 'Submit',
    common_facebook: 'Facebook',
    common_twitter: 'Twitter',
    common_instagram: 'Instagram',
    common_youtube: 'YouTube',
    common_tikTok: 'TikTok',
    common_total_result: 'results found',
    common_email: 'Email',
    common_likes: 'Yes',
    common_dislike: 'No',
    common_is_help: 'Do you find the answer helpful?',
    common_search_null: '0 search results',
    common_video_not_supported: '您的浏览器不支持 video 属性。',
    // header
    header_home: 'Home',
    header_blog: 'Blog',
    header_software: 'Software',
    header_about: 'About Us',
    header_fittings: 'fittings',
    header_support: 'PICO Support',
    header_shop: 'PICO Stores',
    header_newsroom: 'Newsroom',
    // 首页
    home_seo_title: "PICO VR | 官方网站 | PICO中国",
    home_seo_description: "欢迎探索PICO！作为一个拥有自主创新和研发创造能力的科技品牌，PICO 致力于打造领先的世界级XR平台。立即浏览全系列产品。",
    home_seo_keywords: "VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR",
    home_series_products: "Stunning XR Headsets",
    home_series_products_description:`At PICO, we believe that "All-in-One" is the best solution for XR devices. We've been building our whole technology system around the development of All-in-One devices since day one.`,
    home_products_Intro_title1: "Streaming Assistant",
    home_products_Intro_title2:"PICO VR App",
    home_products_Intro_title3:"PICO OS 5.0",
    home_products_Intro_title4:"Remote Play Assistant",
    home_products_Intro_title5: "Cast for PICO",
    home_products_Intro_describe1: "Download the Streaming Assistant now to enjoy SteamVR games on your PICO headset!",
    home_products_Intro_describe2:"Browse games, connect with friends, meet new people in the PICO Community and more.",
    home_products_Intro_describe3:"Super immersive VR experience with brand new UI and feature upgrades.",
    home_products_Intro_describe4:"Stream wirelessly and effortlessly between PICO and other home devices in the same Wi-Fi network.",
    home_products_Intro_describe5: "TV receiver for PICO screencast—high quality, low latency, ad-free.",
    home_news_title: "PICO Newsroom",
    home_news_description: "Find the latest news on PICO",
    home_footer_nav_title1: 'FAQs',
    home_footer_nav_title2: 'Support',
    home_footer_nav_title3: 'About Us',
    // 博客
    blog_keywods: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    blog_title: 'PICO blog',
    // blog_list_seo_title: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_description: 'VR，VR游戏，VR一体机，PICO一体机，玩VR，VR头显，PICO，PICO VR，PICO VR头显，脱机VR',
    // blog_list_seo_keywords: 'PICO，PICO VR，VR游戏',
    blog_search_placeholder: 'Search',
    blog_subscribe_desc: 'Be the first to know new product launch, offerings, and news from PICO!',
    blog_subscribe: 'Subscribe',
    blog_subscribe_success: 'Success!',
    blog_email_placeholder: 'Submit your email address',
    blog_subscribe_email_error: 'Please enter a valid email address',
    blog_buy_now: 'Buy Now',
    blog_poplular_title: 'Popular Posts',
    blog_contact_title: 'Stay Connected',
    blog_breadcrumb_home: 'Home',
    blog_breadcrumb_blog:  'Blog',
    blog_article_nav_title: 'Table of contents',
    blog_copy_email_success: 'Replicating Success',
    blog_game_title: 'Related',
    blog_news_title: 'New Release',
    blog_see_all_articles: 'See all articles',
    blog_related_title: 'Related Articles',
    blog_search_seo_title: '',
    blog_search_seo_description: '',
    blog_search_seo_keywords: '',
    // 服务主页
    support_seo_title: 'VR，VR游戏，VR一体机，PICO一体',
    support_seo_description: 'VR，VR游戏，VR一体机',
    support_seo_keywords: 'VR，VR游戏，VR一体机',
    // support_tilte: 'Support',
    // support_home_banner_title: 'Welcome to PICO Support',
    // support_home_banner_desc: 'PICO is committed to becoming a leading world-class XR platform, achieving developers and creators, and working together.',
    support_home_banner_search_placeholder: 'Search Support',
    support_home_banner_search_Activities: 'Events',
    support_home_banner_search_Software: 'Software',
    support_home_banner_search_Hardware: 'Hardware',
    support_home_banner_search_Streaming: 'Streaming',
    support_home_banner_search_Policy: 'Popular Queries',
    support_home_service_title: 'Quick Support',
    support_home_service_warranty_query: 'Check Warranty',
    support_home_service_warranty_policy: 'Warranty Policy',
    support_home_service_spare_parts_price: 'Replacement Parts Prices',
    support_home_service_FAQs: 'FAQs',
    support_home_service_privacy_clause: 'Privacy Policy',
    support_home_product_title: 'Product Support',
    support_home_product_pico4_desc: 'Imagination, the Only Limitation',
    support_home_product_pico_neo3_desc: 'Immersive Enterprise',
    support_home_shop_title: 'Service Center',
    support_home_contactUs_title: 'Contact Us',
    support_home_contactUs_hotline: 'Hotline',
    support_home_contactUs_online: 'Chat',
    support_home_contactUs_online_chatnow: 'Chat now',
    support_home_contactUs_email: 'Email',
    support_home_contactUs_email_us: 'Email us',
    support_home_contactUs_hotline_tips: 'Local charges may apply',
    // 搜索结果
    support_search_seo_title: '',
    support_search_seo_description: '',
    support_search_seo_keywords: '',
    // 权益
    support_benefit_seo_title: '',
    support_benefit_seo_description: '',
    support_benefit_seo_keywords: '',
    support_benefit_enter_device_SN: 'Enter device SN',
    support_benefit_validate_device_SN: 'Please enter a valid SN',
    support_benefit_view_device_SN: 'How to get device SN?',
    support_benefit_enter_code: 'Enter verification code',
    // support_benefit_validate_enter_code: 'Please Enter Code',
    support_benefit_validate_code_error: 'Please enter the correct verification code',
    support_benefit_notes: 'Notes',
    support_benefit_notes_content1: 'You need to present the paper invoice to claim your warranty. For more details, please refer to the #PICO Product Limited Warranty@http://35.87.238.144/cn/support/after-service#.',
    // support_benefit_notes_link: 'warranty policy',
    support_benefit_notes_content2: 'If you have issues regarding your warranty, please present the proof of purchase (invoice) for verification.',
    // support_benefit_notes_content3: '· You can log in to the PICO Consumer Services official website, click on Warranty and Benefit Inquiry, enter the device serial number and verification code, and view the electronic warranty voucher.',
    // support_benefit_notes_content4: '· If you have any doubts about the query results, you can provide relevant purchase vouchers (invoices) for identification',
    support_benefit_result_title: 'Warranty Services',
    support_benefit_result_product_model: 'Product Model',
    support_benefit_result_product_SN: 'Device SN',
    support_benefit_result_warranty_area: 'Supported Areas',
    support_benefit_result_null: 'No information available',
    // support_benefit_result_warranty_period: 'Warranty Period,
    // support_benefit_result_warranty_service: 'Warranty Services',
    // support_benefit_result_close: 'Close',
    support_benefit_result_product_info: 'Product Information',
    support_benefit_result_benefit_info: 'Rights and Interests',
    SNEQUITY_ISNO: `Device not activated or SN doesn't exist`,
    MESSAGE_CODE_ERROR: "Incorrect verification code. Please enter again.",
    MESSAGE_CODE_EXPIRE: "Verification code expired. Please request another code.",
    // 邮件反馈
    support_email_us_seo_title: 'Email Us',
    support_email_us_seo__description: '',
    support_email_us_seo__keywods: '',
    support_email_us_select: 'Select',
    support_email_us_input: 'Enter',
    support_email_us_title: 'Email Us',
    support_email_us_category: 'Select issue type*',
    support_email_us_product_model: 'Select product model*',
    support_email_us_sn: 'Enter device SN',
    support_email_us_country: 'Select country/region*',
    support_email_us_question_desc: 'Issue description*',
    support_email_us_name: 'Enter your name',
    support_email_us_tel: 'Enter your phone number',
    support_email_us_tel_tips: 'Please enter a valid mobile phone number',
    support_email_us_email: 'Enter your email',
    support_email_us_email_tips: 'Please enter a valid email address',
    support_email_us_code: 'Enter verification code',
    support_email_us_agree: 'I Agree',
    support_email_us_agree_to: 'I have read and agree to [PICO Privacy Policy]',
    support_email_us_upload: 'Upload',
    support_email_us_upload_placeholder: 'Attachment',
    support_email_us_file_size: 'Maximum attachment size: 15 MB',
    support_email_us_privacy_terms: 'privacy terms',
    // support_email_us_privacy_clause: 'Privacy Clause',
    // support_email_us_modal_service_scope: 'Service scope',
    // support_email_us_modal_service_scope_content: 'PICO Innovation guarantees that under normal use, the PICO products you purchase will have no defects in materials or workmanship during the warranty period. The warranty period of this product starts from the day you receive the goods. If you are unable to provide valid evidence such as a purchase invoice, the warranty start date will be extended by 90 days from the factory date shown on the machine, or as otherwise specified by PICO PICO Innovation. Please check the warranty period and after-sales service type of your product in "Part 3- After Sales Service Types".',
    // support_email_us_modal_sales_service: 'How to obtain after-sales service',
    // support_email_us_modal_sales_service_content: 'During the warranty period, if the product cannot achieve the guaranteed functions, please contact PICO Innovation to obtain corresponding after-sales service. PICO Innovation may not provide after-sales service in certain regions, and the content of after-sales service policies may also vary from place to place. Services outside the regular service scope may incur fees. For local information, please contact PICO Innovation.',
    // support_email_us_modal_preparation: 'Preparation before obtaining after-sales service',
    // support_email_us_modal_preparation_content: 'Before obtaining after-sales service for your product, please be sure to follow the following steps: · Follow PICO\'s service process; · Back up all data contained in the product or ensure their security; · Except for flight records, please remove all data from the device, including confidential, proprietary, and personal information. If any such information cannot be deleted, please modify it to prevent others from accessing or making it not constitute personal data as defined by applicable law; · Provide all system passwords to PICO if necessary; · Ensure that PICO can fully, freely, and safely access your equipment to provide after-sales service.',
    // support_email_us_modal_solution: 'PICO\'s Solution',
    // support_email_us_modal_solution_content: 'After contacting PICO Innovation, please provide a detailed explanation of the issues with the product. PICO\'s innovative technical support personnel will attempt to diagnose and solve your problem through phone, email, or remote assistance. PICO can guide you in downloading and installing specified software updates. If your problem cannot be resolved through phone calls or application software updates, you need to send the product back to PICO for further testing. PICO will arrange services according to the types of warranty services enjoyed by the product, and the specific types are specified in "Part III - After Sales Service Types" below.',
    // 聊天弹出框
    support_chart_window_title: 'Welcome to Customer Support',
    support_chart_window_content: 'Welcome to PICO support. Please fill in the form below before starting the chat. The information you enter may contain personal data, and we collect it to provide service for you. Please read the Privacy Policy.',
    support_chart_window_privacy: 'Customer Support Privacy Policy',
    support_chart_window_nickname: 'Name',
    support_chart_window_nickname_input: 'Enter your name',
    support_chart_window_statement: 'Prlvacy Policy',
    support_chart_window_statement_read: 'I have read and agree to PICO Privacy Policy.',
    support_chart_window_chat: 'Chat Now',
    // 维修价格
    support_maintenance_price_seo_title: '',
    support_maintenance_price_seo_description: '',
    support_maintenance_price_seo_keywords: '',
    support_maintenance_price_title: 'Cost of Repair',
    support_maintenance_price_search_category: 'Select product model',
    support_maintenance_price_search_model: 'Enter product name',
    support_maintenance_price_table_title: 'Replacement Parts Prices',
    support_maintenance_price_sparePart_type: 'Replacement Parts Type',
    support_maintenance_price_sparePart_name: 'Replacement Parts Name',
    support_maintenance_price_suggest_price: 'Suggested Retail Price',
    support_maintenance_price_suggest_lower_price: 'Suggested Lower Price',
    // support_maintenance_price_tips1: 'The cost of repair beyond the warranty coverage includes the costs of materials and labor. For each repair, labor is charged only once regardless of the number of parts to be replaced.',
    // support_maintenance_price_tips2: `For parts replacement, there's no charge for labor.`,
    support_maintenance_price_labor_fee: 'Labor Costs',
    support_maintenance_price_service_content: 'Service',
    support_maintenance_price_items: 'Service Type',
    support_maintenance_price_cost: 'Cost',
    support_maintenance_price_notes: 'Notes',
    // FAQ
    support_faq_seo_title: '',
    support_faq_seo_description: '',
    support_faq_seo_keywords: '',
    support_faq_title: 'FAQs',
    support_faq_search: 'Search Support',
    // 保修政策
    support_policy_seo_title: '',
    support_policy_seo_description: '',
    support_policy_seo_keywords: 'If you choose to submit a product warranty',
    support_warranty_policy_title: 'Warranty Policy',
    support_warranty_policy_select: 'Select product model',
    support_warranty_periods_table_title1: 'Product',
    support_warranty_periods_table_title2: 'Replacement Parts Name',
    support_warranty_periods_table_title3: 'Warranty Period',
    // 服务指南
    support_usage_guide_seo_title: '',
    support_usage_guide_seo_description: '',
    support_usage_guide_seo_keywords: '',
    support_usage_guide_title: 'User Guide',
    support_usage_guide_video_title: 'Watch Tutorials',
    support_usage_guide_doc_title: 'Download User Guide',
    // 产品支持
    support_product_seo_title: '',
    support_product_seo_description: '',
    support_product_seo_keywords: '',
    support_product_technical_support: 'Technical Support',
    support_product_technical_parameter: 'Learn more',
    support_product_quick_start_title: 'Quick Start',
    support_product_basic_info_title: 'Product Information',
    support_product_basic_info_desc: 'Learn product details and tech specs',
    support_product_machine_guide_title: 'PICO Setup Guide',
    support_product_machine_guide_desc: 'Quickly get started with your PICO headset',
    support_product_software_download_title: 'Software Download',
    support_product_software_download_desc: 'Download PICO VR mobile app',
    support_product_usage_guide_title: 'Product FAQs',
    support_product_usage_guide_desc: 'Quickly address common issues',
    support_product_popular_forums_title: 'Popular Posts',
    // 产品参数
    support_product_parameter_seo_title: '',
    support_product_parameter_seo_description: '',
    support_product_parameter_seo_keywords: '',
    support_product_parameter_title: 'Product Specs',
    // 维修流程
    support_repair_process_seo_title: '',
    support_repair_process_seo_description: '',
    support_repair_process_seo_keywords: '',
    support_repair_process_banner_title: 'PICO Repair',
    support_repair_process_title: 'Repair & Return Process',
    support_repair_process_step1: 'A malfunction occurred',
    support_repair_process_step2: 'Contact the seller',
    support_repair_process_step3: 'Send the product for repair',
    support_repair_process_step4: 'Repair is done',
    support_repair_process_step5: 'Device is returned',
    support_repair_process_notes: 'Notes',
    support_repair_process_notes_content1: '1. Within the warranty period, no repair costs will be incurred for performance issues caused by product defects.',
    support_repair_process_notes_content2: `2. If some parts need to be replaced due to quality issues, no repair costs will be incurred within the warranty period. After the warranty expires, you'll be charged for the replacement parts, labor and shipping.`,
    support_repair_process_notes_content3: '3. The prices of the replacement parts may be subject to adjustments due to factors like procurement batches, time and suppliers. Please refer to the repair quotation for the actual prices.',
    support_repair_process_notes_content4: '4. The provided repair costs are for reference only. If you have any questions, please contact our after-sales customer service team during working hours.',
    // 门店
    shop_seo_title: '',
    shop_seo_description: '',
    shop_seo_keywords: '',
    shop_banner_watch_now: 'Watch Now',
    shop_experience_title: 'Experience Shop in United',
    shop_offline_title: 'Offline stores in United',
    shop_find_store_title: 'Find a PICO store near you',
    // shop_search_provincial: 'Provincial',
    shop_search_areas: 'Areas',
    shop_search_country: 'Country',
    shop_search_store: 'Store',
    shop_search_select_placeholder: 'Please select',
    shop_search_input_placeholder: 'Please input',
    // 服务门店
    shop_service_list_seo_title: '',
    shop_service_list_seo_description: '',
    shop_service_list_seo_keywords: '',
    shop_service_list_title: 'Service Shop list',
    // 线下门店
    shop_offline_list_seo_title: '',
    shop_offline_list_seo_description: '',
    shop_offline_list_seo_keywords: '',
    shop_offline_list_title: 'Offline Shop list',
    // 最近门店
    shop_nearest_list_seo_title: '',
    shop_nearest_list_seo_description: '',
    shop_nearest_list_seo_keywords: '',
    // 关于我们
    about_us_seo_title: '',
    about_us_seo_description: '',
    about_us_seo_keywords: '',
    about_us_awards_received:'Recognitions',
    about_us_more_exciting: 'More about PICO',
    about_us_more_exciting_title1: 'PICO Community',
    about_us_more_text1: 'Join a community of XR enthusiasts',
    about_us_more_exciting_title2: 'Developer Program',
    about_us_more_text2: 'Become a PICO developer and bring great mixed reality experience to users around the world.',
    about_us_more_exciting_title3: 'PICO Newsroom',
    about_us_more_text3: 'Find the latest official PICO news.',
    about_us_more_exciting_title4: 'Blog',
    about_us_more_text4: 'Discover insights, tips, and stories.',
    about_us_development_milestones: "PICO Milestones",
    about_us_dynamic_effect_title1:"Brand Story",
    about_us_dynamic_effect_desc1:"Our story is intricately linked to extended reality and human exploration. We are dedicated to providing easier access to a more engaging, immersive and fun VR experience through innovative technology, top-notch products and a massive content library. At present, PICO's VR market share is the largest in China and among the top 3 in the world.",
    about_us_dynamic_effect_title2:"Vision and Mission",
    about_us_dynamic_effect_desc2:"Build a leading XR platform, empower developers and creators, and inspire the community.<br/>Bridge connections, release infinity and enrich life.",
    about_us_dynamic_effect_title3:"PICO XR",
    about_us_dynamic_effect_desc3:"PICO is committed to driving the development of the XR industry, continuously generating innovative ideas to meet users' entertainment needs through proprietary full-stack XR OS, immersive visuals, intuitive interactions and human-centered design. ",
    about_us_dynamic_effect_title4:"PICO, Journey to Infinity",
    about_us_dynamic_effect_desc4:"Follow Armstrong to walk on the moon,<br/>or chase the aurora in Greenland.<br/>Put on your PICO,<br/>and embrace the world with all its wonders.",
    // 新闻
    newsroom_seo_title: '',
    newsroom_seo_description: '',
    newsroom_seo_keywords: '',
    newsroom_hot_topic_title: 'PICO Newsroom',
    newsroom_title: 'News Recommendations',
    newsroom_more_news: 'Lastest news',
    // 配件
    spare_part_seo_titile: '',
    spare_part_seo_description: '',
    spare_part_seo_keywords: '',
    //软件
    software_seo_title: '',
    software_seo_description: '',
    software_seo_keywords: '',
    software_download: 'Download Center',
    software_Notes: 'Release Notes',
    software_New: "What's New",
    software_Requirements: 'Requirements',
    software_banner_title: 'Software Ecosystem',
    software_banner_content: 'PICO is committed to building a leading world-class XR platform, with an ecosystem that nurtures the creativity and growth of developers and creators.',
    software_os_title: 'PICO OS 5.0',
    software_os_dialogTitle: 'Choose Your Device',
    software_os_content: 'PICO OS 5.0 is an Android-based operating system designed for All-in-One VR headsets.Through a comprehensive system optimization, PICO OS 5.0 has improved the Ul to provide a cleaner, smoother user experience as you enjoy amassive collection of videos, VR games and apps.',
    software_Applications_title: 'PICO VR App',
    software_Applications_content: 'Explore the PICO VR mobile app. Designed for PICO All-in-One headsets, it helps you manage your headsets with ease. Get started by downloading the app today!',
    software_Assistant_title: 'Streaming Assistant',
    software_Assistant_dialogTitle: 'Choose Your Device',
    software_Assistant_content: 'Streaming Assistant is a set of software tools for streaming support. With Streaming Assistant, you can stream PC games on SteamVR to your PICO headset. Currently, it can be installed on PCs and PICO headsets. The PC version is developed for VR-ready Windows PCs, and SteamVR must be installed to use it. The headset version is for PICO All-in-One VR headsets and requires a 5GHz Wi-Fi router. Before streaming a game, make sure you have installed and configured Streaming Assistant for both the PC and the headset according to the instructions.',
    software_Playback_title: 'Remote Play Assistant',
    software_Playback_dialogTitle: 'Choose Your Device',
    software_Playback_content: 'Remote Play Assistant allows you to stream wirelessly and effortlessly between PICO and other home devices on the same Wi-Fi network. You can now enjoy watching large HD videos without having to copy and transfer videos from other devices to your PICO headset, saving storage on PICO in the process.',
    software_cast_title: 'Cast for PICO',
    software_cast_content: "As PICO's proprietary Android TV receiver, Cast for PICO allows you to share VR experiences by casting the VR view to a smart TV in HD with low latency and zero ads. Amazing moments are always better when shared with friends and family!",
  }
}

export const i18nLocal = {
  'global': 'en',
  'nl': 'en',
  'uk': 'en',
  'fr': 'fr',
  'de': 'de',
  'es': 'es',
  'it': 'it',
  'jp': 'ja',
  'kr': 'ko',
  'sg': 'en',
  'my': 'en',
  'th': 'th-TH',
  'cn': 'zh'
}
